// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__jmXtJ","CodeMirror":"Footer_CodeMirror__69Bj2","footer":"Footer_footer__PxxIj","container":"Footer_container__iICw7"};